import { AssetType, getLoanByAssetIdAndAssetType, Loan } from '@nemuru-eng/js-api-client';
import { useState } from 'react';
import { useParams } from 'react-router';
import { generatePath, useNavigate } from 'react-router-dom';

import { ALLOWED_TRANSACTION_TYPES_FOR_MULTI_SELECT_FILTER } from '@/components/modules/Payouts/PayoutDetails/TransactionsList/constants/constants';
import { useTransactionsList } from '@/components/modules/Payouts/PayoutDetails/TransactionsList/hooks/useTransactionsList';
import { TransactionsListRowProps } from '@/components/modules/Payouts/PayoutDetails/TransactionsList/types/TransactionsListRowProps';
import { TransactionsDataGridFields } from '@/components/modules/Payouts/PayoutDetails/TransactionsList/utils/TransactionsListDataGridFields/TransactionsDataGridFields';
import { MultiFilteredList } from '@/components/shared/components/MultiFilteredList';
import { SubSectionWrapper } from '@/components/shared/components/SubSectionWrapper';
import { Text } from '@/components/shared/components/Text';
import { getDynamicPagePathByOnboardingFulfilledBy } from '@/utils/getDynamicPagePathByOnboardingFulfilledBy';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

const TRANSACTION_TYPES_ITEMS = ALLOWED_TRANSACTION_TYPES_FOR_MULTI_SELECT_FILTER;

function TransactionsList() {
  const { payoutId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // FIXME: This will break the rule of hooks
  if (!payoutId) {
    return null;
  }

  const { fetchTransactionsList } = useTransactionsList({ payoutId });

  const tableColumns = TransactionsDataGridFields();

  const goToOrderDetailView = async (orderId: string) => {
    setLoading(true);
    const loan: Loan = await getLoanByAssetIdAndAssetType({ assetId: orderId, assetType: AssetType.ORDER });
    navigate(
      generatePath(getDynamicPagePathByOnboardingFulfilledBy(loan.onboardingDetails[0].fulfilledBy), {
        loanId: loan.id,
      }),
    );
  };

  return (
    <>
      <SubSectionWrapper title={'TRANSACTIONS_LIST'}>
        <MultiFilteredList
          fetchList={fetchTransactionsList}
          dataGridFields={tableColumns}
          onRowClick={(rowData: TransactionsListRowProps) => {
            if (rowData.row.orderId) goToOrderDetailView(rowData.row.orderId);
          }}
          multiselectProps={{
            field: 'type',
            label: <Text tId={'TRANSACTION_TYPE'} />,
            defaultLabel: <Text tId={'DEFAULT_TYPES'} />,
            items: TRANSACTION_TYPES_ITEMS,
            checkBoxRender: (value) => <Text tId={value} />,
            filtersValueHandler: undefined,
            defaultItems: ALLOWED_TRANSACTION_TYPES_FOR_MULTI_SELECT_FILTER,
          }}
          dateFilterProps={{
            dateField: 'updated_at',
          }}
          defaultOrderBy={'order_id'}
          loading={loading}
          disableSelectionOnClick
        />
      </SubSectionWrapper>
    </>
  );
}

export const TransactionsListModule = withPermissionsModule(TransactionsList);
